export default "__VITE_ASSET__DL$5bZZF__"